var c = Object.defineProperty;
var l = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, h = Object.prototype.propertyIsEnumerable;
var n = (o, C, e) => C in o ? c(o, C, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[C] = e, a = (o, C) => {
  for (var e in C || (C = {}))
    s.call(C, e) && n(o, e, C[e]);
  if (l)
    for (var e of l(C))
      h.call(C, e) && n(o, e, C[e]);
  return o;
};
import { jsx as r, jsxs as d } from "react/jsx-runtime";
const v = ({
  iconId: o,
  color: C,
  heigth: e,
  size: t,
  width: i
}) => ({
  Check: /* @__PURE__ */ r(
    "svg",
    {
      width: t || i || "10",
      height: t || e || "8",
      viewBox: "0 0 10 8",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ r(
        "path",
        {
          d: "M1 4.00016L3.66667 6.66683L9 1.3335",
          stroke: C || "var(--color-grayScale-white)",
          strokeWidth: "1.2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  ),
  Trash: /* @__PURE__ */ d(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ r(
          "path",
          {
            d: "M8.54916 5.63072C8.52824 5.27321 8.52824 4.91488 8.54916 4.55737C8.59731 4.13015 8.81097 3.73515 9.14856 3.44917C9.48614 3.16319 9.92354 3.00662 10.3759 3.00988C11.4504 2.99671 12.5249 2.99671 13.5994 3.00988C13.8457 3.00761 14.0899 3.05241 14.3176 3.14158C14.5452 3.23075 14.7517 3.36248 14.9247 3.52895C15.0977 3.69542 15.2337 3.89325 15.3246 4.11064C15.4155 4.32803 15.4595 4.56056 15.4539 4.79442C15.4539 5.0644 15.4539 5.33769 15.4539 5.63072H15.7069H20.1644C20.2716 5.6272 20.3789 5.63715 20.4834 5.66034C20.6376 5.70026 20.7726 5.78958 20.8654 5.91319C20.9583 6.03679 21.0033 6.18705 20.9929 6.33857C20.9788 6.49301 20.9078 6.63779 20.7924 6.7474C20.677 6.85701 20.5246 6.92445 20.362 6.93783C20.0154 6.93783 19.6688 6.93783 19.3013 6.93783C19.1627 6.93783 19.1003 6.96418 19.0899 7.11563C18.949 9.36989 18.8022 11.6252 18.6497 13.8817C18.5527 15.4061 18.4556 16.9305 18.3481 18.4549C18.3083 19.1365 17.995 19.7778 17.4729 20.2469C16.9507 20.7159 16.2593 20.9772 15.5406 20.977C13.1801 20.977 10.823 20.977 8.46598 20.977C7.7366 20.9697 7.03841 20.695 6.51717 20.2103C5.99593 19.7256 5.69201 19.0684 5.66881 18.3759C5.56482 16.6013 5.42616 14.8233 5.30137 13.0487C5.19277 11.4946 5.0865 9.94278 4.98251 8.39312C4.95478 7.9618 4.92012 7.53377 4.89932 7.10245C4.89932 6.97404 4.84039 6.93783 4.7156 6.94112C4.38978 6.94112 4.0674 6.94112 3.74158 6.94112C3.55772 6.94112 3.38136 6.87174 3.25135 6.74824C3.12135 6.62475 3.04834 6.45727 3.04834 6.28263C3.04834 6.10798 3.12135 5.9405 3.25135 5.81701C3.38136 5.69352 3.55772 5.62413 3.74158 5.62413H8.24765L8.54916 5.63072ZM6.33083 6.99381C6.33083 7.05966 6.33083 7.12551 6.33083 7.19465C6.42095 8.68944 6.51224 10.1864 6.60467 11.6856C6.74332 13.8883 6.88541 16.0876 7.01713 18.2903C7.01546 18.4778 7.05417 18.6637 7.13086 18.8365C7.20755 19.0093 7.3206 19.1654 7.4631 19.2952C7.60559 19.425 7.77452 19.5258 7.9595 19.5914C8.14448 19.6569 8.34166 19.6858 8.53884 19.6764H15.4712C15.6686 19.6863 15.8659 19.6577 16.0511 19.5923C16.2363 19.527 16.4054 19.4262 16.548 19.2963C16.6906 19.1664 16.8036 19.0101 16.8802 18.8371C16.9567 18.6641 16.995 18.478 16.9929 18.2903C16.9929 18.0104 17.0275 17.7306 17.0483 17.4507C17.1569 15.7825 17.2725 14.1143 17.3949 12.4461C17.4897 11.004 17.5844 9.56192 17.6792 8.11982C17.7034 7.75435 17.7242 7.38562 17.7485 6.99381H6.33083ZM14.0535 5.62413C14.0625 5.6062 14.0695 5.58743 14.0744 5.56814C14.0744 5.33767 14.0744 5.1039 14.0744 4.87014C14.0744 4.50796 13.9322 4.36967 13.5544 4.36638H10.4348C10.1714 4.36638 9.9738 4.47175 9.95993 4.66601C9.9322 4.99525 9.95993 5.30147 9.95993 5.62413H14.0535Z",
            fill: "var(--color-negativeFeedback)"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M9.92547 13.2957C9.92547 14.4612 9.92547 15.6235 9.92547 16.7891C9.93338 16.9518 9.87749 17.1115 9.76866 17.2374C9.65983 17.3632 9.50572 17.4463 9.33615 17.4706C9.16629 17.4933 8.99364 17.4553 8.85151 17.3641C8.70938 17.2729 8.60787 17.1349 8.56666 16.9767C8.54797 16.8968 8.53988 16.8149 8.54246 16.7331V9.88799C8.54246 9.71334 8.61546 9.54586 8.74547 9.42237C8.87548 9.29888 9.05184 9.22949 9.2357 9.22949C9.41956 9.22949 9.59583 9.29888 9.72584 9.42237C9.85585 9.54586 9.92894 9.71334 9.92894 9.88799C9.92547 11.0206 9.92547 12.1598 9.92547 13.2957Z",
            fill: "var(--color-negativeFeedback)"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M11.3084 13.2955C11.3084 12.1366 11.3084 10.9908 11.3084 9.82199C11.3089 9.66148 11.3711 9.50667 11.4833 9.38667C11.5956 9.26668 11.7501 9.18977 11.9178 9.17036C12.0855 9.15095 12.255 9.1904 12.3942 9.28129C12.5335 9.37218 12.633 9.50826 12.6741 9.66395C12.6845 9.75918 12.6845 9.85517 12.6741 9.9504C12.6741 12.1893 12.6741 14.4292 12.6741 16.6703C12.6741 16.7197 12.6741 16.7691 12.6741 16.8152C12.6741 16.9899 12.601 17.1573 12.471 17.2808C12.341 17.4043 12.1647 17.4737 11.9808 17.4737C11.797 17.4737 11.6206 17.4043 11.4906 17.2808C11.3606 17.1573 11.2876 16.9899 11.2876 16.8152C11.3049 15.6398 11.3084 14.4644 11.3084 13.2955Z",
            fill: "var(--color-negativeFeedback)"
          }
        ),
        /* @__PURE__ */ r(
          "path",
          {
            d: "M14.0782 13.2955C14.0782 12.1366 14.0782 10.9908 14.0782 9.82199C14.0787 9.66148 14.1409 9.50667 14.2531 9.38667C14.3653 9.26668 14.5198 9.18977 14.6876 9.17036C14.8553 9.15095 15.0247 9.1904 15.164 9.28129C15.3033 9.37218 15.4028 9.50826 15.4438 9.66395C15.4601 9.75861 15.4659 9.8546 15.4612 9.9504C15.4612 12.1893 15.4612 14.4292 15.4612 16.6703C15.4612 16.7197 15.4612 16.7691 15.4612 16.8152C15.4612 16.9899 15.3881 17.1573 15.2581 17.2808C15.1281 17.4043 14.9518 17.4737 14.7679 17.4737C14.5841 17.4737 14.4077 17.4043 14.2777 17.2808C14.1477 17.1573 14.0747 16.9899 14.0747 16.8152C14.0747 15.6398 14.0782 14.4644 14.0782 13.2955Z",
            fill: "var(--color-negativeFeedback)"
          }
        )
      ]
    }
  )
})[o], k = (o) => /* @__PURE__ */ r(v, a({}, o));
export {
  k as Icons
};
